import { Injectable } from '@angular/core';
import { Address, AddressAPIResponse } from '../interfaces/adress';


@Injectable({
  providedIn: 'root'
})

export class AddressAdapter {

    public adapterToModel(addressFHIR: AddressAPIResponse): Address {
        
        const addressModel: Address = {
          cep: '',
          country: '',
          state: '',
          city: '',
          street: '',
          number: '',
          complement: ''
        };
      
        if (addressFHIR) {
          addressModel.cep = addressFHIR.postalCode ?? '';
          addressModel.country = addressFHIR.country ?? '';
          addressModel.state = addressFHIR.state ?? '';
          addressModel.city = addressFHIR.city ?? '';
      
          const extraInfos = addressFHIR.line;
          if (extraInfos) {
            addressModel.street = extraInfos[0] ?? '';
            addressModel.number = extraInfos[1] ?? '';
            addressModel.complement = extraInfos[2] ?? '';
          }
        }
      
        return addressModel;
      }


    public adaptToAPIFormat(adressModel: Address): AddressAPIResponse[]{

        return [
            {
                use: "work",
                type: "physical",
                line: [adressModel.street ?? '', adressModel.number ?? '', adressModel.complement ?? ''],
                postalCode: adressModel.cep,
                country: adressModel.country,
                state: adressModel.state,
                city: adressModel.city

            }
        ]
    }


}